import * as React from 'react'

import type { IDrawerConfig } from '@/Core/Contracts/UI/Drawer'
import { useProfiler } from '../../Utils/profilerHelpers'
import { createDrawerContext, DrawerContextProvider } from './DrawerContextProvider'

export interface DrawerProps extends IDrawerConfig {
    /** Вкладені елементи */
    children?: React.ReactNode
    /** Контекст drawer (опціонально) */
    drawerContext?: any
}

/**
 * Компонент Drawer
 * Поєднує UIManager, Antd Drawer та кастомну логіку
 */
export const Drawer: React.FC<DrawerProps> = ({ drawerContext, ...props }) => {
    // Інтеграція з профайлером в dev режимі
    const { addEvent, setStatus } = useProfiler('Drawer', 'component', '/Core/UI/Drawer/Drawer.tsx', [props])

    React.useEffect(() => {
        setStatus('active')
        addEvent('initialized', {
            open: props.open,
            title: props.title,
            placement: props.placement,
        })
    }, [])

    React.useEffect(() => {
        addEvent('state_change', { open: props.open })
        setStatus(props.open ? 'active' : 'inactive')
    }, [props.open])

    if( !drawerContext )
        drawerContext = createDrawerContext({ ...props })
    else
        drawerContext.mergeProps({ ...props })
    
    return (
        <DrawerContextProvider value={{ drawerContext }}>
            {drawerContext.render()}
        </DrawerContextProvider>
    )
}

export default Drawer
